import ProcurementZoneType from './ProcurementZoneTypes';

/** Lane Search Actions start */
export const getProcurementZoneListInProgress = (payload) => {
  return {
    type: ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST,
    payload,
  };
};

export const getProcurementZoneListInSuccess = (payload) => {
  return {
    type: ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST_SUCCESS,
    payload,
  };
};

export const getProcurementZoneListInFail = (payload) => {
  return {
    type: ProcurementZoneType.GET_PROCUREMENT_ZONE_LIST_FAIL,
    payload,
  };
};

export const setProcurementZoneListRequest = (payload) => {
  return {
    type: ProcurementZoneType.SET_PROCUREMENT_ZONE_LIST_REQUEST,
    payload,
  };
};

export const resetProcurementZoneList = (payload) => {
  return {
    type: ProcurementZoneType.RESET_PROCUREMENT_ZONE_LIST,
    payload,
  };
};
/** Lane Search Actions end */

export const setActiveZoneItemsRequest = (payload) => {
  return {
    type: ProcurementZoneType.SET_ACTIVE_ZONE_ITEM,
    payload,
  };
};

export const resetActiveZoneItemsRequest = () => {
  return {
    type: ProcurementZoneType.RESET_ACTIVE_ZONE_ITEM,
  };
};

export const setAddNewZone = (payload) => {
  return { type: ProcurementZoneType.SET_ADD_NEW_ZONE, payload };
};

export const updateZoneLocationList = (payload) => {
  return { type: ProcurementZoneType.UPDATE_ZONE_LOCATION_LIST, payload };
};
